import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import patientPortalApi from "../../api/patientPortalApi";
import { getToken, clearToken, setToken } from "../../utils/tokenManager";
import PatientPortalLayout from "./components/PatientPortalLayout";
import PatientPortalInfoCard from "./components/PatientPortalInfoCard";
import PatientPortalResultTable from "./components/PatientPortalResultTable";
import PatientPortalActivityCards from "./components/PatientPortalActivityCards";
import FullScreenSpinner from "../../components/FullScreenSpinner";
import { calcularProgreso } from "../../utils/progresUtils";

export default function PatientPortalDashboard() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [paciente, setPaciente] = useState(() => {
    try {
      const savedUser = sessionStorage.getItem("patient_user");
      if (savedUser) {
        const u = JSON.parse(savedUser);
        return {
          fullName: u.nombre,
          Identificacion: u.identificacion,
          Tipo_id: u.tipo_id,
        };
      }
    } catch {}
    return null;
  });
  const [edad, setEdad] = useState(null);
  const [grupos, setGrupos] = useState([]);
  const [actividades, setActividades] = useState([]);
  const [porcentaje, setPorcentaje] = useState(0);

  const handleLogout = () => {
    clearToken();
    sessionStorage.removeItem("patient_token");
    sessionStorage.removeItem("patient_user");
    navigate("/portal-paciente/login", { replace: true });
  };

  useEffect(() => {
    const token = getToken() || sessionStorage.getItem("patient_token");
    if (!token) {
      handleLogout();
      return;
    }
    if (!getToken()) {
      setToken(token);
    }

    const cargarDatos = async () => {
      try {
        setLoading(true);
        const [resResumen, resActividades] = await Promise.all([
          patientPortalApi.getResumen(),
          patientPortalApi.getActividades(),
        ]);

        if (resResumen?.success && resResumen?.data) {
          setPaciente(resResumen.data.paciente);
          setEdad(resResumen.data.edad);
          setGrupos(resResumen.data.grupos || []);
        }

        if (resActividades?.success && resActividades?.data) {
          const listActividades = resActividades.data.actividades || [];
          setActividades(listActividades);

          // Calcular porcentaje de cumplimiento
          const prog =
            calcularProgreso(listActividades) ||
            resActividades.data.porcentajeCumplimiento ||
            0;
          setPorcentaje(prog);
        }
      } catch (error) {
        console.error("Error al cargar datos del portal:", error);
        toast.error(
          error.response?.data?.message ||
            "Error al consultar la información del paciente. Inicie sesión nuevamente."
        );
        handleLogout();
      } finally {
        setLoading(false);
      }
    };

    cargarDatos();
  }, [navigate]);

  return (
    <PatientPortalLayout
      patientName={paciente?.fullName || "PACIENTE"}
      onLogout={handleLogout}
    >
      {/* SECCIÓN 1: Tarjeta de Información Demográfica (Responsive para PC, Tablet y Móvil) */}
      {paciente && (
        <PatientPortalInfoCard
          paciente={paciente}
          edad={edad}
          grupos={grupos}
          porcentaje={porcentaje}
        />
      )}

      {/* SECCIÓN 2A: Vista de Tabla para PC y Tablet (Pantallas >= 768px) */}
      <PatientPortalResultTable data={actividades} />

      {/* SECCIÓN 2B: Vista de Tarjetas de Actividades para Móvil (Pantallas < 768px) */}
      <PatientPortalActivityCards data={actividades} />

      {loading && <FullScreenSpinner text="Cargando información de salud..." />}
    </PatientPortalLayout>
  );
}
